import { UserManagementMap } from "./userManagementAction";

const initialState = {
  referralHistory: [],
  isReferralHistoryLoading: false,
  isLoading: false,
  userList: {},
  activityList: {},
  refreshUserList: true,
  refreshActivities: true,
  selectedUser: {},
  country: "",
  minDate: new Date(new Date().setMonth(new Date().getMonth() - 1)),
  maxDate: new Date(),
  searchBy: "",
  searchText: "",
  activitySkip: 0,
  activityLimit: 10,
  skip: 0,
  limit: 10,
  dir: "",
  reDirect: false,
  defaultPassword: "",
  userStats: {},
  avtarList: {},
  refreshAvtarList: true,
  isJury: { value: "", label: "All" },
  topUserSkip: 0,
  topUserLimit: 10,
  topUserSearch: "",
  topUserList: {},
  refreshTopUserList: true,
  toDate: "",
  fromDate: "",
  type: { value: "followers", label: "Followers" },
  topUserSearchBy: "followers",
  topUserDir: "dsc",
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case UserManagementMap.GET_USER_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case UserManagementMap.GET_USER_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        userList: action.payload,
        refreshUserList: false,
        refreshActivities: true,
      };
    }
    case UserManagementMap.GET_USER_ERROR: {
      return {
        ...state,
        isLoading: false,
        refreshUserList: false,
      };
    }

    case UserManagementMap.GET_USER_STATE_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case UserManagementMap.GET_USER_STATE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        userStats: action.payload,
      };
    }
    case UserManagementMap.GET_USER_STATE_ERROR: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case UserManagementMap.CREATE_USER_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case UserManagementMap.CREATE_USER_SUCCESS: {
      return {
        ...state,
        refreshUserList: true,
        reDirect: true,
      };
    }
    case UserManagementMap.CREATE_USER_ERROR: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case UserManagementMap.UPDATE_USER_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case UserManagementMap.UPDATE_USER_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        refreshUserList: true,
        refreshActivities: true,
        selectedUser: {
          ...state.selectedUser,
          ...action.payload,
        },
        reDirect: true,
      };
    }
    case UserManagementMap.UPDATE_USER_ERROR: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case UserManagementMap.UPDATE_USER_BUYER_DETAIL_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case UserManagementMap.UPDATE_USER_BUYER_DETAIL_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        refreshUserList: true,
        refreshActivities: true,
        selectedUser: {
          ...state.selectedUser,
          ...action.payload,
        },
        reDirect: true,
      };
    }
    case UserManagementMap.UPDATE_USER_BUYER_DETAIL_ERROR: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case UserManagementMap.DELETE_USER_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case UserManagementMap.DELETE_USER_SUCCESS: {
      return {
        ...state,
        refreshUserList: true,
        selectedUser: null,
      };
    }
    case UserManagementMap.DELETE_USER_ERROR: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case UserManagementMap.SET_DEFAULT_PASSWORD_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case UserManagementMap.SET_DEFAULT_PASSWORD_SUCCESS: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case UserManagementMap.SET_DEFAULT_PASSWORD_ERROR: {
      return {
        ...state,
      };
    }
    case UserManagementMap.GET_DEFAULT_PASSWORD_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case UserManagementMap.GET_DEFAULT_PASSWORD_SUCCESS: {
      return {
        ...state,
        isLoading: true,
        defaultPassword: action.payload.defaultPassword,
      };
    }
    case UserManagementMap.GET_DEFAULT_PASSWORD_ERROR: {
      return {
        ...state,
      };
    }
    case UserManagementMap.REMOVE_ALL_ACTIVITIES_START: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case UserManagementMap.REMOVE_ALL_ACTIVITIES_ERROR: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case UserManagementMap.SELECT_USER_DETAILS: {
      return {
        ...state,
        selectedUser: action.payload,
        refreshActivities: true,
        reDirect: false,
      };
    }
    case UserManagementMap.REMOVE_ACTIVITY_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case UserManagementMap.REMOVE_ACTIVITY_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        refreshActivities: true,
      };
    }
    case UserManagementMap.REMOVE_ACTIVITY_ERROR: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case UserManagementMap.REMOVE_ALL_ACTIVITIES_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        refreshActivities: true,
        selectedUser: {
          ...state.selectedUser,
          ...action.payload,
        },
      };
    }
    case UserManagementMap.APPLY_FILTERS:
    case UserManagementMap.COUNTRY_FILTERS: {
      return {
        ...state,
        ...action.payload,
        refreshUserList: true,
        refreshActivities: true,
        searchText: "",
        skip: initialState.skip,
        limit: initialState.limit,
      };
    }
    case UserManagementMap.SEARCH_TEXT_CHANGE: {
      return {
        ...state,
        searchText: action.payload,
      };
    }
    case UserManagementMap.REFRESH_USER_LIST: {
      return {
        ...state,
        skip: 0,
        refreshUserList: true,
      };
    }
    case UserManagementMap.SET_USER_BATCH_NUMBER: {
      return {
        ...state,
        skip: action.payload,
        refreshUserList: true,
      };
    }

    case UserManagementMap.SET_ACTIVITIES_BATCH_NUMBER: {
      return {
        ...state,
        activitySkip: action.payload,
        refreshActivities: true,
      };
    }

    case UserManagementMap.GET_ALL_ACTIVITY_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case UserManagementMap.GET_ALL_ACTIVITY_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        activityList: action.payload,
        refreshActivities: false,
      };
    }
    case UserManagementMap.GET_ALL_ACTIVITY_ERROR: {
      return {
        ...state,
        isLoading: false,
        refreshActivities: false,
      };
    }
    case UserManagementMap.SET_SORT_CHANGE: {
      return {
        ...state,
        searchBy: action.payload?.column,
        dir: action.payload?.dir,
        refreshUserList: true,
        refreshActivities: true,
      };
    }

    case UserManagementMap.GET_AVTAR_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case UserManagementMap.GET_AVTAR_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        avtarList: action.payload,
        reDirect: false,
        refreshAvtarList: false,
      };
    }
    case UserManagementMap.GET_AVTAR_ERROR: {
      return {
        ...state,
        isLoading: false,
        refreshAvtarList: false,
      };
    }

    case UserManagementMap.CREATE_AVTAR_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case UserManagementMap.CREATE_AVTAR_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        reDirect: true,
        refreshAvtarList: true,
      };
    }
    case UserManagementMap.CREATE_AVTAR_ERROR: {
      return {
        ...state,
        isLoading: false,
        refreshAvtarList: false,
      };
    }

    case UserManagementMap.UPDATE_AVTAR_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case UserManagementMap.UPDATE_AVTAR_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        refreshAvtarList: true,
      };
    }
    case UserManagementMap.UPDATE_AVTAR_ERROR: {
      return {
        ...state,
        isLoading: false,
        refreshAvtarList: false,
      };
    }

    case UserManagementMap.SET_SELECT_CHANGE: {
      return {
        ...state,
        isJury: action.payload,
        skip: 0,
        refreshUserList: true,
      };
    }

    case UserManagementMap.UPDATE_JURYADMINWITHDRAWAL_START: {
      return {
        ...state,
        // isLoading: true,
      };
    }
    case UserManagementMap.UPDATE_JURYADMINWITHDRAWAL_SUCCESS: {
      return {
        ...state,
        // isLoading: false,
      };
    }
    case UserManagementMap.UPDATE_JURYADMINWITHDRAWAL_ERROR: {
      return {
        ...state,
        // isLoading: false,
      };
    }

    case UserManagementMap.GET_TOP_USER_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case UserManagementMap.GET_TOP_USER_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        topUserList: action.payload,
        refreshTopUserList: false,
      };
    }
    case UserManagementMap.GET_TOP_USER_ERROR: {
      return {
        ...state,
        isLoading: false,
        refreshTopUserList: false,
      };
    }
    case UserManagementMap.SET_TOP_USER_CHANGE: {
      return {
        ...state,
        topUserSearch: action.payload,
      };
    }
    case UserManagementMap.REFRESH_TOP_USER_LIST: {
      return {
        ...state,
        topUserSkip: 0,
        refreshTopUserList: true,
      };
    }

    case UserManagementMap.SET_TOP_USER_BATCH_NUMBER: {
      return {
        ...state,
        topUserSkip: action.payload,
        refreshTopUserList: true,
      };
    }
    case UserManagementMap.SET_TO_DATE_CHANGES: {
      return {
        ...state,
        toDate: action.payload,
      };
    }
    case UserManagementMap.SET_FROM_DATE_CHANGES: {
      return {
        ...state,
        fromDate: action.payload,
      };
    }
    case UserManagementMap.GET_USER_WITH_DATE_CHANGES: {
      return {
        ...state,
        refreshTopUserList: true,
      };
    }
    case UserManagementMap.SET_TYPE_TOP_USER_CHANGES: {
      return {
        ...state,
        type: action.payload,
        topUserSearchBy: action.payload.value,
        skip: 0,
      };
    }
    case UserManagementMap.SET_SORT_FOR_TOP_USER_CHANGE: {
      return {
        ...state,
        topUserSearchBy: action.payload?.column,
        topUserDir: action.payload?.dir,
        refreshTopUserList: true,
      };
    }
    case UserManagementMap.RESET_FILTERS: {
      return {
        ...state,
        toDate: "",
        fromDate: "",
        type: { value: "", label: "Select" },
        topUserSearch: "",
        topUserSearchBy: "",
        topUserDir: "",
        refreshTopUserList: true,
      };
    }

    case UserManagementMap.SEND_TOKEN_HISTORY_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case UserManagementMap.SEND_TOKEN_HISTORY_SUCCESS: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case UserManagementMap.SEND_TOKEN_HISTORY_ERROR: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case UserManagementMap.GET_USER_REFERRAL_HISTORY_START: {
      return {
        ...state,
        isReferralHistoryLoading: true,
      };
    }
    case UserManagementMap.GET_USER_REFERRAL_HISTORY_SUCCESS: {
      return {
        ...state,
        isReferralHistoryLoading: false,
        referralHistory: action.payload,
      };
    }
    case UserManagementMap.GET_USER_REFERRAL_HISTORY_ERROR: {
      return {
        ...state,
        isReferralHistoryLoading: false,
      };
    }

    default:
      return { ...state };
  }
};
